import { useCommonDataContext } from "@core/CommonDataContext";
import cn from "classnames";
import { useCallback, useMemo } from "react";
import { useSelectFilters } from "@vms/SelectFilters/SelectFiltersContext";
import { HeatScore } from "@models/HeatScore";
import { toggleInArray } from "@core/utils/array";
import { capitalize, FCX } from "@datassential/platform-ui-lib";

const SelectHeatScores: FCX = ({
    className,
    testId,
}) => {
	const { isLoading, heatScores } = useCommonDataContext();

	const { selectedFilters, setSelectedFilters } = useSelectFilters();

	const handleSelect = useCallback((heatScoreId: HeatScore) => () => {
		setSelectedFilters((selectedFilters) => ({
			...selectedFilters,
			heatScores: toggleInArray(selectedFilters.heatScores, heatScoreId),
		}));
	}, [setSelectedFilters]);

	const items = useMemo(() => {
		return (heatScores ?? [])
			.filter((i) => i.id !== undefined)
			.map((i, index) => {
				const onClick = handleSelect(i.id ?? 0);
				const isSelected = selectedFilters.heatScores.includes(i.id ?? 0);
				return (
					<div
						className={
							cn(
								"SelectFiltersButtons__item",
								isSelected && "is-selected",
							)
						}
						key={i.id}
						onClick={onClick}
						data-testid={`buttonSelectHeatScoresItem_${index}`}
					>
						{capitalize(i.name)}
					</div>
				);
			});
	}, [heatScores, selectedFilters.heatScores, handleSelect]);

	if (isLoading) {
		return null;
	}

	return (
		<div
			className={cn("SelectFiltersButtons", className)}
			data-testid={testId}
		>
			<div
				className="SelectFiltersButtons__title"
				data-testid="textSelectHeatScores"
			>
				HEAT SCORE
			</div>
			<div
				className="SelectFiltersButtons__items"
				data-testid="blockSelectHeatScoresItems"
			>
				{items}
			</div>
		</div>
	);
}

export default SelectHeatScores